<div
  class="fixed w-full bottom-0 z-[1000]"
  data-testid="notification-block"
>
  @for (notification of notifications; track notification) {
    <div
      class="mx-5 my-4 shadow-S overflow-hidden"
      [@messageState]="{
        value: 'visible',
        params: {
          showTransformParams: showTransformOptions,
          hideTransformParams: hideTransformOptions,
          showTransitionParams: showTransitionOptions,
          hideTransitionParams: hideTransitionOptions,
        },
      }"
    >
      @if (notification?.key === 'message') {
        <app-notification-message-atom
          (closeMessage)="close(notification)"
          (clickMessage)="click(notification)"
          [message]="notification?.data?.message"
        ></app-notification-message-atom>
      }
    </div>
  }
</div>
